export const blockIconsAudioandvideoRadioNew = (
	<span className='material-symbols-outlined'>radio</span>
);
